import { apiWidget } from "apiConnections";
import { AxiosRequestConfig } from "axios";
import RequestUrlId from "types/RequestUrlId";

const requests = {
    fetchLive: (config: AxiosRequestConfig) =>
        apiWidget.get(`/games/live`, config),
    fetchQR: (config: AxiosRequestConfig) =>
        apiWidget.get(`/games/qr`, config),
    fetchActivities: (config: AxiosRequestConfig) =>
        apiWidget.get(`/games/activities`, config),
    getAvailability: (config: AxiosRequestConfig) =>
        apiWidget.get(`/games/availability`, config),
    getDayAvailability: (config: AxiosRequestConfig) =>
        apiWidget.get(`/games/availability/day`, config),
    getTableAvailability: (config: AxiosRequestConfig) =>
        apiWidget.get(`/games/table/availability`, config),
    getGameAvailability: (config: AxiosRequestConfig, url: RequestUrlId) =>
        apiWidget.get(`/games/game/${url.id}/availability`, config),
    contact: (data: object, config: AxiosRequestConfig) =>
        apiWidget.post(`/games/contact`, data, config),
    checkout: (data: object, config: AxiosRequestConfig) =>
        apiWidget.post(`/games/checkout`, data, config),
    calculate: (config: AxiosRequestConfig) =>
        apiWidget.post(`/games/payment/calculate`, config),
};

export default requests;
